import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  tabs: {
    '& ul': {
      padding: 0,
    },
    height: '100%',
  },
  tabHeader: {
    background: theme.palette.background.paper,
    borderBottom: `3px solid ${theme.palette.secondary.main}`,
    borderRadius: '4px 4px 0 0',
    height: '45px',
    display: 'flex',
    alignItems: 'center',
    margin: '0',
    '& li:nth-child(1)': {
      marginLeft: '15px',
    },
    '& li': {
      display: 'inline',
      color: theme.palette.text.disabled,
      paddingRight: '24px',
      cursor: 'pointer',
    },
    '& li.active': {
      color: theme.palette.secondary.main,
    },
    '& li:hover': {
      color: theme.palette.secondary.main,
    },
  },
  tabContent: {
    height: '90%',
    color: theme.palette.text.primary,
    background: theme.palette.background.paper,
    border: `1px solid ${theme.palette.grey[500]}`,
    width: '100%',
    position: 'relative',
    borderRadius: '0 0 4px 4px',
    padding: '1rem',
  },
  tabChild: {},
}));

export default useStyles;
